<template>
  <div :class="setStyle" data-test="outside-vif">
    <template v-if="isRaftStyling">
      <div v-if="config?.isB4" class="loading-throbber">
        <b-spinner class="align-middle" />
      </div>
      <div v-else>
        <img
          src="/sites/all/modules/hide_submit/images/squares.gif"
          alt="loading"
        />
      </div>
      <strong>{{ busyText }}</strong>
    </template>
    <template v-else>
      <div class="loading-spinner-container">
        <p>{{ busyText }}</p>
        <div class="loader"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { useDrupalSettings } from "@/composables/useDrupalSettings";

const { config } = useDrupalSettings();

export default {
  name: "RaftBusy",
  data() {
    return {
      config: config,
    };
  },
  props: {
    busyText: { type: String, required: true },
    isRaftStyling: { type: Boolean, default: true },
  },
  computed: {
    setStyle() {
      return this.isRaftStyling
        ? "busy-throbber-wrapper"
        : "busy-spinner-wrapper";
    },
  },
};
</script>

<style scoped>
div.busy-throbber-wrapper {
  display: inline-block;
}

.loading-spinner-container > p {
  font-size: var(--font-size-75);
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 5em;
  height: 5em;
}
.loader {
  position: relative;
  text-indent: -9999em;
  border-top: 0.9em solid var(--gray-300);
  border-right: 0.9em solid var(--gray-300);
  border-bottom: 0.9em solid var(--gray-300);
  border-left: 0.9em solid var(--gray-600);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
